export default __webpack_public_path__ + "static/media/donate-now.908c1885.svg";